import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';

import { SHARED_IMPORTS } from '../shared/shared-imports';
import { ContentService } from '../../services/content.service';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';


@Component({
	selector: 'user-list-component',
	standalone: true,
	templateUrl: 'components/user-list/user-list.component.html',
	imports: [
		...SHARED_IMPORTS,
		MatButtonModule,
		MatSlideToggleModule,
		MatIconModule,
		ConfirmDialogComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UserListComponent implements OnInit {
	users: any[] = [];
	roles: any[] = [];
	rolesFiltered: any[] = [];
	roleLowerThanManager: any;
	currentRole: any;
	readMode = false;
	user: any;

	private http = inject(HttpClient);
	private router = inject(Router);
	private content = inject(ContentService);
	private dialog = inject(MatDialog);

	constructor() { }

	async ngOnInit(): Promise<void> {
		await this.getRoles();
		await this.getUsers(); // getUsers will now apply roles immediately
		this.handleUserRoleFiltering();
	}

	goBack(): void {
		// TODO: Implement proper navigation history tracking if needed
		// For now, default to Main
		this.router.navigate(['/Main']);
	}

	getUsers(): Promise<void> {
		return new Promise((resolve) => {
			this.http.get('/api/user/Users').subscribe((result: any) => {
				this.users = result;

				// Set roles immediately
				this.users.forEach(user => {
					user.role = this.roles.find(r => r.Id === user.GlobalAppRoleId);
					this.getPermission(user); 
				});

				resolve();
			});
		});
	}


	getPermission(user: any): void {
		this.http
			.get('/api/user/GetUserPermissionForChangingUserActivation', {
				params: { UserId: user.Id },
			})
			.subscribe((result: any) => {
				user.disableActivationChange = result;
			});
	}

	getRoles(): Promise<void> {
		return new Promise((resolve) => {
			this.http.get('/api/user/Roles').subscribe((result: any) => {
				this.roles = result;
				this.rolesFiltered = [...this.roles];
				this.roleLowerThanManager = this.roles.find(r => r.RoleName === 'Manager');
				resolve();
			});
		});
	}

	private handleUserRoleFiltering(): void {
		if (this.user) {
			this.currentRole = this.roles.find(r => r.Id === this.user.GlobalAppRoleId);

			this.readMode = this.user.GlobalAppRoleId.localeCompare(
				this.roleLowerThanManager.Id
			) === 1;

			if (
				this.user.GlobalAppRoleId.localeCompare(
					this.roleLowerThanManager.Id
				) === 0
			) {
				this.rolesFiltered = this.roles.filter(r => r.RoleName !== 'Administrator');
			}
		}

		this.users.forEach(user => {
			user.role = this.roles.find(r => r.Id === user.GlobalAppRoleId);
		});
	}

	isDisabled(user: any): boolean {
		if (this.readMode) return true;

		if (
			this.user &&
			user &&
			this.user.GlobalAppRoleId.localeCompare(user.GlobalAppRoleId) === 1
		) {
			return true;
		}

		return false;
	}

	changeUserStatus(user: any): void {
		this.getPermission(user);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: {
				title: this.content.getContent(
					'User.AreYouSureYouWantTo' + (user.Active ? 'Activate' : 'Deactivate')
				),
				text: user.Email,
				okText: this.content.getContent('Standard.Yes'),
				cancelText: this.content.getContent('Standard.No')
			}
		});

		dialogRef.afterClosed().subscribe(confirmed => {
			if (confirmed) {
				this.http
					.get(`/api/user/${user.Active ? 'Activate' : 'Deactivate'}`, {
						params: { UserId: user.Id }
					})
					.subscribe();
			} else {
				// Revert status if user canceled
				user.Active = !user.Active;
			}
		});
	}

}
